














































































































import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import { mapState, mapActions, mapGetters} from 'vuex'
import Loading  from '@/components/Loading.vue'
import NoData from '@/components/NoData.vue'
import { formatDateTime, formatRaceDateTime } from '@/utils/date'
import TranslateMixin from '@/mixins/translate'
import { handleOpenApp, init } from '@/utils/lanuchApp';
import { getPara } from '@/utils/util'


import { Route } from 'vue-router';
import { Store } from 'vuex';

interface SSRContext {
  meta?: {
    title: string;
    description: string;
    imageUrl: string;
  };
}

interface AsyncDataParams {
  store: Store<any>;
  route: Route;
  ssrContext: SSRContext | null;
  app: Vue;
}

declare const YT:any
declare const window: any
var player: any = null

@Component({
  computed: mapGetters([
    'initData',
    'topicFeedList'
  ]),
  methods: mapActions([
    'getTopicFeedList',
    'reportSend',
  ]),
  components: {
    Loading,
    NoData
  }
})
export default class extends Mixins(TranslateMixin) {
  private query!: any;

  private topicFeedList!: any;

  getTopicFeedList!: (params: object) => Promise<void>;
  reportSend!: (params: object) => Promise<void>;

  private feeds = [];
  private empty = true;
  private openid = 0;
  private videoFormatMap = {
    "MPEG": "video/mpeg",
    "MPG": "video/mpeg",
    "MP4": "video/mp4",
    "M4V": "video/mp4",
    "3GP": "video/3gpp",
    "3GPP": "video/3gpp",
    "3G2": "video/3gpp2",
    "3GPP2": "video/3gpp2",
    "MKV": "video/x-matroska",
    "WEBM": "video/webm",
    "TS": "video/mp2ts",
    "AVI": "video/avi",
    "WMV": "video/x-ms-wmv",
    "ASF": "video/x-ms-asf",
  } as any;
  private clientLang = typeof window != 'undefined' && (getPara('lang', location.href) || 'en');

  private topicDetail = {};

  // 包跳转协议 
  private schema = 'igame1320'

  async asyncData({ store, route, ssrContext }: AsyncDataParams) {
    // try {
    //   // console.error("****** asyncData call begin", route, ssrContext);
    //   const { openid, id, ticket } = route.query;
    //   const openId = openid;
    //   const feedDetail = await store.dispatch('getTopicFeedList', {valueOfType: 20, topicId: id, openid: openId, openId, ticket});
    //   // console.error("****** asyncData feedDetail", store.state, feedDetail);
    //   // 在这里设置元数据
    //   const { topicDetail } = feedDetail || store.state.topicFeedList.topicDetail;
    //   const {
    //     topicDesc,
    //     topicIcon,
    //     topicName
    //   } = topicDetail;
    //   let title = topicName;
    //   let description = topicDesc;
    //   let imageUrl  = topicIcon;

    //   if (ssrContext) {
    //     ssrContext.meta = { title, description, imageUrl };
    //   }
    //   return { title, description, imageUrl };
    // } catch (error) {
    //   console.error('Error during asyncData:', error);
    //   return { title: '', description: '', imageUrl: '' };
    // }
  }

  async created() {
    await init();
    this.query = this.$route.query
    console.log('** test params:', this.query);
    const { id, openid, ticket, schema } = this.query;
    if (schema) {
      this.schema = schema;
    }
    this.openid = openid;
    await this.loadFeeds(id, openid, ticket);

    const param = {
      common: {
        openid
      },
      param: {
        topicid: this.topicFeedList.topicDetail.topicid,
        content: this.topicFeedList.topicDetail.topicDesc || this.topicFeedList.topicDetail.topicName,
        action: "feed",
        subaction: "h5_topic"
      }
    };

    await this.reportSend(param)

  }

  private async loadFeeds (id: number, openId: string, ticket: string) {
    await this.getTopicFeedList({valueOfType: 20, topicId: id, openid: openId, openId, ticket});
    console.log("topic feed list:", this.topicFeedList);
    if (this.topicFeedList.error) {
      this.empty = true;
      return;
    }
    this.empty = false;
    const { bodys, topicDetail } = this.topicFeedList;
    this.topicDetail = topicDetail;
    // 解析feeds
    let feeds = [] as any;
    bodys.forEach((body: any) => {
      const {
        data,
        source,
        topicCtx, // 话题标签
        iid,
        type,
        ownerInfo,
        greatNum,
        commNum,
        zoneToPublic,
        owner,
        time,
        canGreat,
      } = body;
      let commentData = {} as any;
      if (data) {
        const { content, video, image_urls, text_story_config} = JSON.parse(data);
        // 拆分tag
        let tags = ''
        let newContent = content
        if (content && content.indexOf('#') !== -1) {
          const index = content.indexOf('#')
          tags = content.substring(index)
          newContent = content.substring(0, index)
        }
        if (!tags) {
          topicCtx && topicCtx.forEach( (t: any) => {
            tags += `#${t.content}`;
          });
        }
        const timeStr = formatRaceDateTime(new Date(time*1));
        commentData = {
          content: newContent,
          rawContent: content,
          tags,
          videoUrl: video.video_url,
          imageUrl: image_urls && image_urls[0],
          vid: video.vid,
          poster: video.img_url,
          nickname: ownerInfo.nickname,
          avatar: ownerInfo.avatar,
          greatNum,
          commNum,
          iid,
          isOwner: owner == this.openid,
          canDelete: false,
          owner,
          time: timeStr && timeStr.split(" ")[0],
          bgColor: text_story_config ? `#${text_story_config.bgColor1.toString(16).substring(2) || text_story_config.bgColor2.toString(16).substring(2)}` : '',
          canGreat,
        };
      }
      commentData.source = source
      commentData.videoType = this.getVideoType(commentData.videoUrl)
      commentData.thirdPlayUrl = ''
      commentData.sourceType = type // FEED_TYPE_IMAGE 图片  FEED_TYPE_VEDIO: 视频
      commentData.zoneToPublic = zoneToPublic;
      if (commentData.source === 'FOR_FACEBOOK') {
        if (!commentData.videoType) {
          // facebook 如果不是播放源，则用facebook的播放器， 否则用video标签
          commentData.thirdPlayUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(commentData.videoUrl)}&autoplay=true&allowfullscreen=true`;
        }
      } else if (commentData.source === 'FOR_YOUTUBE') {
        if (!player && typeof document !== 'undefined') {
          // 初始化播放器脚本
          var tag = document.createElement('script');

          tag.src = "https://www.youtube.com/iframe_api";
          var firstScriptTag = document.getElementsByTagName('script')[0] as any
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

          // 3. This function creates an <iframe> (and YouTube player)
          //    after the API code downloads.
          window.onYouTubeIframeAPIReady = function() {
            player = new YT.Player('player', {
              events: {
                'onReady': window.onPlayerReady,
              }
            });
          }

          // 4. The API will call this function when the video player is ready.
          window.onPlayerReady = function(event: any) {
            event.target.playVideo();
            // event.target.mute();  // 静音就不能自动播放，  开启声音播放， 需要用户触发
          }
        }
      }
      feeds.push(commentData);
    });
    this.feeds = feeds;
  }

  private getVideoType (url: string) {
    if (!url) {
      return '';
    }
    const lastDotIndex = url.lastIndexOf('.') as number;
    if (lastDotIndex < 0 ) {
      return '';
    }
    return this.videoFormatMap[(url.substring(lastDotIndex + 1).toUpperCase())];
  }

  mounted() {

  }

  destroyed () {

  }

  private jumpClub (e: Event) {
    console.log('**** jumpTest:', e)
    const { page, id, extra } = this.query;
    var app = {
        scheme: `${this.schema}://`,
        schemeLaunchParam: `module=100030?deeplink=${encodeURIComponent(`igamesdk://meemo/${page}?id=${id}&extra=${extra}`)}`,
        downloadUrl: 'market://details?id=com.tencent.ig',
        path: 'module=100030',
        params: {
          deeplink: `${encodeURIComponent(`igamesdk://meemo/${page}?id=${id}&extra=${extra}`)}`,
        },
        schemeOnly: this.schema,
    }
    handleOpenApp(app);
  }

  private go2Feeds (iid: string) {
    console.log('clicked go2Feeds:', iid);
    // if (typeof window != 'undefined') {
    //   window.location.href = `igamesdk://meemo/normal_feed_detail?type=4&id=${iid}`;
    // }
  }

  private go2User (target_openid: string) {
    console.log('clicked go2User:', target_openid);
    // if (typeof window != 'undefined') {
    //   window.location.href = `igamesdk://meemo/home_page?type=4&target_openid=${target_openid}`;
    // }
  }

}
